import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { MyMLabel } from '../ui-elements/MyMLabel';

/** MyMine Version2.0 新規作成
 * CustomDataGrid Component
 * 
 * @param {any} param0
 * @returns
 * @remarks 
 * MyMDataGrid・PagingDataGridだとコンポーネントの制約上、一度に最大100件までしか表示できないため、
 * 100件を超える一覧表示を行う場合はこのコンポーネントを使用する
 */
const CustomDataGrid = (
  {
    name,
    columns,
    dataList,
    uniquyKey,
  }) => {

  const theme = useTheme();

  return (
    <TableContainer className='h-100 overflow-x-visible'>
      <Table className='h-100 d-block' name={name}>
        <TableHead className='d-block' sx={{ backgroundColor: theme.palette.background.secondary }}>
          <TableRow className='d-flex'>
            {columns.map((column) => (
              <TableCell key={column.field} className='p-2' sx={{ flex: column.flex }}>
                <MyMLabel className='fw-medium text-white' >{column.headerName}</MyMLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody
          className='h-100 d-block overflow-auto'
          sx={{ maxHeight: 'calc(100% - 42px)', }}>
          {dataList.map((data) => (
            <TableRow key={uniquyKey(data)} className='d-flex' sx={{ '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}>
              {columns.map((column) => (
                <TableCell key={column.field} className='d-flex align-items-center p-2' sx={{ flex: column.flex, borderRight: '1px solid #ddd' }}>
                  <MyMLabel>{data[column.field]}</MyMLabel>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default CustomDataGrid;